import React from "react";
import PropTypes from "prop-types";
import { dispatchFetchCarouselById } from "helpers/carousel-helper";
import GridQueryCarousels from "../../shared/carousels/grid-query-carousels";
import { connect } from "react-redux";

class CarouselById extends React.Component {
  static propTypes = {
    carouselId: PropTypes.string.isRequired,
    carousel: PropTypes.object,
    carouselInGrid: PropTypes.bool,
    carouselLoggingData: PropTypes.object,
    deadEndCarousel: PropTypes.bool,
    deadEndSearchData: PropTypes.object,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    dispatch: PropTypes.func,
    favorites: PropTypes.array,
    filters: PropTypes.object,
    neighborly: PropTypes.bool,
    shortlists: PropTypes.array,
  };

  componentDidMount() {
    const { carouselId, carousel } = this.props;

    if (!carousel && carouselId) {
      this.loadCarousel();
    }
  }

  loadCarousel() {
    const { dispatch, filters = {}, carouselId } = this.props;

    dispatchFetchCarouselById(dispatch, carouselId, { filters });
  }

  render() {
    const { carousel, carouselInGrid, carouselLoggingData, deadEndCarousel, deadEndSearchData, dispatch, neighborly } =
      this.props;

    if (carousel) {
      return (
        <GridQueryCarousels
          carouselInGrid={carouselInGrid}
          extraPixelData={carouselLoggingData}
          deadEndCarousel={deadEndCarousel}
          deadEndSearchData={deadEndSearchData}
          dispatch={dispatch}
          displayedModal={this.props.displayedModal || ""}
          favorites={this.props.favorites}
          forceShowUnlimitedAnnotation={true}
          neighborly={neighborly}
          productCarousels={[carousel]}
          shortlists={this.props.shortlists}
        />
      );
    }

    return <div />;
  }
}

function mapStateToProps(state) {
  return {
    carousel: state.carousel,
  };
}

export default connect(mapStateToProps)(CarouselById);
